// Небольшое хранилище IndexedDB «ключ → запись» для данных, которые не помещаются в localStorage (файлы билетов
// в «Кошельке поездки»). Всё остаётся в этом браузере и доступно без интернета. Без IndexedDB — ошибка с понятным текстом.
const DB = 'sayohat';
const VERSION = 1;
const STORES = ['wallet'] as const;
export type IdbStore = (typeof STORES)[number];

let opening: Promise<IDBDatabase> | null = null;

function open(): Promise<IDBDatabase> {
  if (opening) return opening;
  opening = new Promise((resolve, reject) => {
    if (typeof indexedDB === 'undefined') { reject(new Error('Браузер не поддерживает хранение файлов')); return; }
    const req = indexedDB.open(DB, VERSION);
    req.onupgradeneeded = () => { for (const s of STORES) if (!req.result.objectStoreNames.contains(s)) req.result.createObjectStore(s, { keyPath: 'id' }); };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => { opening = null; reject(new Error('Не удалось открыть хранилище браузера')); };
  });
  return opening;
}

function run<T>(store: IdbStore, mode: IDBTransactionMode, fn: (s: IDBObjectStore) => IDBRequest): Promise<T> {
  return open().then((db) => new Promise<T>((resolve, reject) => {
    const tx = db.transaction(store, mode);
    const req = fn(tx.objectStore(store));
    tx.oncomplete = () => resolve(req.result as T);
    tx.onerror = () => reject(new Error(tx.error?.name === 'QuotaExceededError' ? 'В браузере кончилось место' : 'Ошибка хранилища браузера'));
  }));
}

export const idb = {
  all: <T>(store: IdbStore): Promise<T[]> => run<T[]>(store, 'readonly', (s) => s.getAll()),
  put: <T extends { id: string }>(store: IdbStore, value: T): Promise<void> => run<unknown>(store, 'readwrite', (s) => s.put(value)).then(() => undefined),
  delete: (store: IdbStore, id: string): Promise<void> => run<unknown>(store, 'readwrite', (s) => s.delete(id)).then(() => undefined),
};
